export default {
  defaultTitle: {
    en: 'Add to queue',
  },
}
